import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { TargetGroups } from '../components/TargetGroups';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { CTA } from '../components/CTA';
import { Footer } from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <TargetGroups />
        <Services />
        <Process />
        <WhyUs />
        <FAQ />
        <CTA />
      </main>
      <Footer />
      <div className="noise-overlay" />
    </div>
  );
};

export default Home;
